import React from "react" 
import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  CardSubtitle,
  Table,
  InputGroup,
} from "reactstrap"
import { addStream } from "service/api"

const defaultValue = {
  stream: "",
  color: ""
}
const Addstream = () => {
  const [stream, setStream] = useState(defaultValue);
  const [errors, setErrors] = useState({});
   const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();

   useEffect(() => {
          document.title = "Stream | Add Stream";
        }, []);

  const onValueChange = (e) => {
  const { name, value } = e.target;
  setStream({ ...stream, [name]: value });

  // Clear field-specific validation error
  if (errors[name]) {
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  }
};


  const validate = () => {
    let formErrors = {};
    if (!stream.stream.trim()) {
      formErrors.stream = "Stream name is required";
    }
    if (!stream.color) {
      formErrors.color = "Color is required";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAddStream = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // start loader
    try {
      await addStream(stream);
      toast.success("Stream saved successfully.", {
        position: "top-center",
        autoClose: 1500,
      });
      navigate("/stream");
    } catch (error) {
      toast.error("Failed to save stream.");
      console.error(error);
    } finally {
      setLoading(false); // stop loader
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title"> Add Stream </h4>
            <Link to="/stream" className="btn btn-danger">Stream List</Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">Stream<span style={{ color: "red" }}>*</span>
</Label>
                        <Input
                          type="text"
                          className={`form-control ${errors.stream ? "is-invalid" : ""}`}
                          name="stream"
                          Placeholder="Stream Name"
                          onChange={e => onValueChange(e)}
                        />
                        {errors.stream && <div className="invalid-feedback">{errors.stream}</div>}
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Color<span style={{ color: "red" }}>*</span>

                        </Label>
                        <Input
                          type="color"
                         className={`form-control ${errors.color ? "is-invalid" : ""}`}
                          name="color"
                          onChange={e => onValueChange(e)}
                        />
                         {errors.color && <div className="invalid-feedback">{errors.color}</div>}
                      </div>
                    </Col>
                  </Row>
                  <div>
                     <Button
                      color="primary"
                      className="w-md mx-2"
                      onClick={handleAddStream}
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default  Addstream ;
